import React from 'react'
import styled from '@emotion/styled'
import FadeDownWrap from 'src/components/atoms/FadeDown'
import { css } from '@emotion/core'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'
import { vwSize } from 'src/utils/vwCss'

const MemberCard = ({ image, name, position, description, ...props }) => (
  <Card {...props}>
    <FadeDownWrap>
      <CardWrap>
        {image && <Thumbnail src={image} />}
        <Introduction>
          <NameWrap>
            <Name as="h3" className={"g-h3"}>{name}</Name>
            <Position as="p" css={positionCss} className={"-position"}>
              {position}
            </Position>
          </NameWrap>
          <Description as="p" css={descriptionCss}>
            {description}
          </Description>
        </Introduction>
      </CardWrap>
    </FadeDownWrap>
  </Card>
)

const Card = styled.div`
  width: 100%;
  background-color: ${Styles.color.grayscale[100]};
  filter: drop-shadow(8px 8px 20px rgba(112, 181, 197, 0.15));
  border-radius: ${Styles.pc.borderRadius};
  overflow: hidden;
  margin-bottom: ${vwSize(32, 'pc')}vw;

  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    border-radius: ${Styles.sp.borderRadius};
    margin-bottom: ${vwSize(32, 'sp')}vw;
  }

  &:nth-of-type(3) {
    .-position {
      @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
        width: 14em !important;
      }
    }
  }
`
const CardWrap = styled.div`
  display: flex;
  box-sizing: border-box;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    flex-direction: column;
  }

  &:nth-child(3) {
    .-position {
      @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
        width: 14em;
      }
    }
  }
`

const Thumbnail = styled.img`
  width: ${vwSize(320, 'pc')}vw;
  display: block;
  box-sizing: border-box;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    width: 100%;
  }
`
const Introduction = styled.div`
  box-sizing: border-box;
  width: calc(100% - ${vwSize(320, 'pc')}vw);
  padding: ${vwSize(25, 'pc')}vw ${vwSize(32, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    width: 100%;
    padding: ${vwSize(24, 'sp')}vw ${vwSize(16, 'sp')}vw;
  }
`
const NameWrap = styled.div`
  display: flex;
  align-items: center;
`
const Name = styled(Typography)`
  margin-right: ${vwSize(16, 'pc')}vw;
  white-space: nowrap;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-right: ${vwSize(16, 'sp')}vw;
  }
`
const positionCss = css`
  color: ${Styles.color.secondary[300]};
  font-weight: ${Styles.fontWeight.bold};
  font-size: ${Styles.pc.fontSize.text};
  letter-spacing: ${Styles.pc.letterSpacing};
  line-height: ${Styles.lineHeight[350]};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.tag};
  }
`
const Position = styled(Typography)`
`
const Description = styled(Typography)`
  font-size: ${Styles.pc.fontSize.text};
  line-height: ${Styles.lineHeight[500]};
  margin-top: ${vwSize(16, 'pc')}vw;
  letter-spacing: ${Styles.pc.letterSpacing};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.text};
    margin-top: ${vwSize(16, 'sp')}vw;
  }
`
const descriptionCss = css`
`

export default MemberCard
